/** Paleta TikTok (métricas): solo rojo, blanco y negro. */

export const TIKTOK_RED = "#E50914";
export const TIKTOK_BLACK = "#010101";
export const TIKTOK_WHITE = "#FFFFFF";

/** RGB principal del rojo (`rgba(...)` para barras y rellenos). */
export const TIKTOK_RED_RGB = "229, 9, 20";

/** RGB del negro (opacidades en barras/planos). */
export const TIKTOK_BLACK_RGB = "1, 1, 1";
